import type { AppRouteModule } from '@/router/types';

import { LAYOUT } from '@/router/constant';
import { RoleEnum } from '@/enums/roleEnum';

const Knowledge: AppRouteModule = {
  path: '/knowledgeManage',
  name: 'KnowledgeManage',
  identify: 'knowledgeManage',
  component: LAYOUT,
  redirect: '/knowledgeManage/knowledge',
  meta: {
    icon: 'icon-park-outline:list-view',
    title: '知识管理',
    roles: [RoleEnum.OFFLINE],
  },
  children: [
    {
      path: 'knowledge',
      name: 'Knowledge',
      identify: 'knowledgeManage',
      component: () => import('@/views/knowledgeManage/index.vue'),
      meta: {
        title: '知识管理',
        hideMenu: true,
        hideTab: true,
        currentActiveMenu: '/knowledgeManage',
        roles: [RoleEnum.OFFLINE],
      },
    },
    {
      path: 'knowledgeAdd',
      name: 'KnowledgeAdd',
      identify: 'knowledgeManage',
      component: () => import('@/views/knowledgeManage/add.vue'),
      meta: {
        title: '新建知识库',
        hideMenu: true,
        hideTab: true,
        currentActiveMenu: '/knowledgeManage',
        roles: [RoleEnum.OFFLINE],
      },
    },
    {
      path: 'knowledgeEdit',
      name: 'KnowledgeEdit',
      identify: 'knowledgeManage',
      component: () => import('@/views/knowledgeManage/edit.vue'),
      meta: {
        title: '编辑知识库',
        hideMenu: true,
        hideTab: true,
        currentActiveMenu: '/knowledgeManage',
        roles: [RoleEnum.OFFLINE],
      },
    },
    {
      path: 'knowledgeDetails',
      name: 'KnowledgeDetails',
      identify: 'knowledgeManage',
      component: () => import('@/views/knowledgeManage/details.vue'),
      meta: {
        title: '内容详情',
        hideMenu: true,
        hideTab: true,
        currentActiveMenu: '/knowledgeManage',
        roles: [RoleEnum.OFFLINE],
      },
    },
  ],
};

export default Knowledge;
